import BaseApi from './BaseApi';

class MessageTemplateApi extends BaseApi {
  protected getSpecificApiPrefix(): string {
    return 'managers/message-templates';
  }
}

export default MessageTemplateApi;
